import { httpClient } from './httpClient';

const baseMaterias = '/api/materias';
const baseVideos = '/api/materia-videos';

// Videos de respaldo por materia (capítulos/módulos) — se configuran una vez
// por materia y aplican a todas sus promociones en Campus.
export const listarVideosDeMateria = (materiaId) =>
  httpClient.get(`${baseMaterias}/${materiaId}/videos`);

export const crearVideoDeMateria = (materiaId, payload) =>
  httpClient.post(`${baseMaterias}/${materiaId}/videos`, payload);

export const actualizarVideoDeMateria = (id, payload) =>
  httpClient.put(`${baseVideos}/${id}`, payload);

export const eliminarVideoDeMateria = (id) => httpClient.del(`${baseVideos}/${id}`);

const materiaVideosService = {
  listar: listarVideosDeMateria,
  crear: crearVideoDeMateria,
  actualizar: actualizarVideoDeMateria,
  eliminar: eliminarVideoDeMateria,
};

export default materiaVideosService;
